import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { Title, Button, FacebookShare } from '../components'

const PageHeader = ({ title, button, center, share }) => (
  <div className={`page-header ${center ? 'center' : ''}`}>
    <Title message={title} />
    <h1>{title}</h1>
    {
      button && button.link &&
      <Link to={button.link}>
        <Button
          positive
          big
          className="disable-spacing-right"
        >
          {button.text}
        </Button>
      </Link>
    }
    {
      (button && !button.link) && button
    }
    {/*
      share &&
      <FacebookShare url={share} />
    */}
  </div>
)

PageHeader.defaultProps = {
  button: null,
  center: false,
  share: null,
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  share: PropTypes.string,
  button: PropTypes.any,
  center: PropTypes.bool,
}

export default PageHeader



// WEBPACK FOOTER //
// ./src/browser/components/PageHeader.js